/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Spinner, Modal, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./CandidateDashboard.scss";
import useCandidateDashboard from "./useCandidateDashboard";
import {
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import AssessmentCard from "./_components/AssessmentCard";
import ScheduledInterviewCard from "./_components/ScheduledInterviewsCard";
import MainLayout from "../../../_components/Common/MainLayout";
export default (props) => {
  const {
    assignedAssessmentKits,
    candidateProfile,
    resumeUploadModal,
    scheduledInterviews,
    scheduledInterviewsLoading,
    assignAssesmentKitsLoading,
    interviewInvites,
    interviewInvitesLoading,
 
    onShareProfileClick,
    onStartAssessmentClick,
    onViewAssessmentDetailsClick,
    onTakeAssessmentClick,
    onViewDetailsClick,
    getStatusCount,
    calculatePercentage,
    handleResumeUploadModal,
    onResumeUpload,
    onJoinHMSClick,
    viewScheduleCalenderHandler,
  } = useCandidateDashboard();

  return (
    <> 
      <MainLayout activeMenuItem="home" pageName="Dashboard" user={candidateProfile} candidateProfile={candidateProfile} onShare={onShareProfileClick}>
        <div className="candidate-dashboard  position-relative footer-gap">
          <div className="hiring-board">
            <div className="container">
              <div className="row mb-3 mx-0 mt-2">
                <div className="col-lg-8 mb-4">
                  <div className="dashboard-component-container bg-white border border-radius-10 px-3 pt-3 h-100  dashboard-assessment-kits">
                    <div className="d-flex justify-content-between mb-4">
                      <h3 className="mr-2">Assessment Kits</h3>
                    </div>

                    {assignAssesmentKitsLoading ? (
                      <Spinner animation="border" variant="primary" />
                    ) : (
                      <div className="assesment-list">
                        {Array.isArray(assignedAssessmentKits) &&
                          assignedAssessmentKits.length ? (
                          <>
                            <AssessmentCard
                              assignedAssessmentKits={assignedAssessmentKits}
                              onStartAssessmentClick={onStartAssessmentClick}
                              onViewAssessmentDetailsClick={onViewAssessmentDetailsClick}
                              calculatePercentage={calculatePercentage}
                              onTakeAssessmentClick={onTakeAssessmentClick}
                              onViewDetailsClick={onViewDetailsClick}
                              getStatusCount={getStatusCount}
                            />
                          </>
                        ) : (
                          <div
                            className="d-flex align-items-center justify-content-center flex-column py-4"
                          >
                            <img
                              src="/assets/images/empty-state.svg"
                              alt="empty"
                            />
                            <h4 className="font-weight-bold mb-1 mt-2">
                              No assessment is assigned to you
                            </h4>
                            <p className="mb-4 fs-smallest">
                              Start Applying to Jobs
                            </p>
                            <Link
                              to={"/job-board"}
                              className="px-4 border border-primary shadow
                          text-primary py-1 rounded-lg font-weight-semi"
                            >
                              See Jobs
                            </Link>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 mb-4">
                <div className="dashboard-component-container border border-radius-10 p-3 bg-white h-100">
                    <div className="d-flex align-items-center justify-content-between">
                      <h3>Upcoming Interviews</h3>
                    </div>

                    <Tabs defaultActiveKey="PendingInterviews" className="mt-3">
                      <Tab eventKey="PendingInterviews" title="Invitations">
                        {interviewInvitesLoading ? (
                          <div className="d-flex justify-content-center align-items-center p-4">
                            <Spinner animation="border" variant="primary" />
                          </div>
                        ) : (
                          <>
                            {Array.isArray(interviewInvites) &&
                              interviewInvites.length ? (
                              <>
                                {Array.isArray(interviewInvites) &&
                                  interviewInvites.map((item) => (
                                    <div className="bg-grey mt-3 p-3 bg-grey-4 border rounded  d-flex cursor-pointer align-items-start">
                                      <span className="mr-4 fs-smallest">
                                        <strong className="text-capitalize">
                                          {item?.event_availability_details &&
                                            item?.event_availability_details
                                              ?.event_details &&
                                            item?.event_availability_details
                                              ?.event_details?.event_creator &&
                                            item?.event_availability_details
                                              ?.event_details?.event_creator
                                              ?.full_name}
                                        </strong>{" "}
                                        has invited you to schedule an interview
                                      </span>
                                      {item?.is_scheduled === false ? (
                                        <button
                                          className="ml-auto btn py-1 px-2 fs-smallest text-nowrap btn-light"
                                          onClick={() =>
                                            viewScheduleCalenderHandler(
                                              item?.event_availability_details
                                                ?.hash_id,
                                              item?.candidate_job_application
                                            )
                                          }
                                        >
                                          Schedule Now
                                        </button>
                                      ) : (
                                        <button
                                          className="ml-auto btn py-1 px-2 fs-smallest text-nowrap btn-light"
                                          disabled
                                        >
                                          Scheduled
                                        </button>
                                      )}
                                    </div>
                                  ))}
                              </>
                            ) : (
                              <div className="text-center pt-4">
                                <img
                                  src="/assets/images/empty-state.svg"
                                  alt="empty"
                                />
                                <h4>No Interview Invites Received</h4>
                              </div>
                            )}
                          </>
                        )}
                      </Tab>
                      <Tab eventKey="ScheduledInterviews" title="Scheduled">
                        {scheduledInterviewsLoading ? (
                          <div className="d-flex justify-content-center align-items-center p-4">
                            <Spinner animation="border" variant="primary" />
                          </div>
                        ) : (
                          <>
                            {Array.isArray(scheduledInterviews) &&
                              scheduledInterviews.length ? (
                              <>
                                {Array.isArray(scheduledInterviews) &&
                                  scheduledInterviews.map(
                                    (scheduledInterview) => (
                                      <ScheduledInterviewCard
                                        scheduledInterview={scheduledInterview}
                                        onJoinHMSClick={onJoinHMSClick}
                                      />
                                    )
                                  )}
                              </>
                            ) : (
                              <div className="text-center pt-4">
                                <img
                                  src="/assets/images/empty-state.svg"
                                  alt="empty"
                                />
                                <h4>No Interview Invites Received</h4>
                              </div>
                            )}
                          </>
                        )}
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          show={resumeUploadModal}
          centered
          onHide={() => handleResumeUploadModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Resume Upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Please Upload Your Resume</p>
            <input
              className="form-control bg-transparent pb-2 h-auto"
              type="file"
              name="resume"
              accept=".pdf"
              onChange={onResumeUpload}
            />
          </Modal.Body>
        </Modal>
      </MainLayout>
    </>
  );
};
